// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoProcessor_video__1Sooa","videoBuffer":"VideoProcessor_videoBuffer__3RSLO","videoOutput":"VideoProcessor_videoOutput__2JNeD"};